import { useState } from 'react'

import GymService from 'service/GymService'
import { ISaveGroupLessonReservation } from 'types/GymType'
import AuthUtil from 'utils/AuthUtil'

export default function useSaveGroupLessonReservation(
  resInfo: ISaveGroupLessonReservation,
  closeAfterSave: () => void
) {
  const [loading, setLoading] = useState(false)
  const employeeId = AuthUtil.getEmployeeSummary()?.id

  const saveGroupLessonReservation = () => {
    setLoading(true)
    GymService.saveGymGroupLessonReservation({
      ...resInfo,
      id: 0,
      employeeId: employeeId,
      isCancel: false,
    })
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { saveGroupLessonReservation, loading }
}
